import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Play } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

export default function Suspended() {
  const { activeProperty } = useAuth();
  const [rows, setRows] = useState([]);

  const load = async () => {
    if (!activeProperty) return;
    try {
      const { data } = await api.get(
        `/vehicles?property_id=${activeProperty.id}&status=suspended`
      );
      setRows(data || []);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, [activeProperty]);

  const reactivate = async (id) => {
    try {
      await api.post(`/vehicles/${id}/reactivate`);
      toast.success("Vehicle reactivated");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="mono-tiny text-[#71717A]">Suspended</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight mt-2">
          Suspended vehicles ({rows.length})
        </h1>
      </div>

      <div className="bg-white border border-[#E4E4E7] rounded-lg divide-y divide-[#E4E4E7]">
        {rows.length === 0 && (
          <div className="p-6 text-sm text-[#71717A]">No suspended vehicles.</div>
        )}
        {rows.map((v) => (
          <div key={v.id} className="p-5 flex items-center justify-between" data-testid={`suspended-${v.id}`}>
            <div>
              <div className="font-medium">
                {v.year} {v.make} {v.model}
              </div>
              <div className="mono-tiny text-[#71717A] mt-1">
                {v.license_plate} · {v.state}
              </div>
            </div>
            <Button
              onClick={() => reactivate(v.id)}
              className="bg-[#0F8F4F] hover:bg-[#0A6B3B] h-10"
              data-testid={`suspended-reactivate-${v.id}`}
            >
              <Play className="w-4 h-4 mr-2" /> Reactivate
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
